import { getRoles } from "services/commonServices";
import { GET_ROLES_FAILURE, GET_ROLES_REQUEST, GET_ROLES_SUCCESS } from "./action-type";
import { SOMS_API_KEY } from "services/CONSTANTS";

export const getRolesAction = () => {

    const request = {
      apikey: SOMS_API_KEY,
    }

    return (dispatch) => {
        dispatch(getRolesRequest());
        getRoles(request)
            .then((response) => {
                if (response.status === 200)
                    dispatch(getRolesSuccess(response));
                else
                    dispatch(getRolesFailure(response));
            })
            .catch((err) => {
                dispatch(getRolesFailure(err));
            });

    };
}

export const getRolesRequest = () => {
    return {
        type: GET_ROLES_REQUEST
    }
};

export const getRolesSuccess = (response) => {
    return {
        type: GET_ROLES_SUCCESS,
        getRolesResponse: response.data,
        isGetRolesError: false,
        isGetRolesSuccess: true
    }
};

export const getRolesFailure = (error) => {
    return {
        type: GET_ROLES_FAILURE,
        getRolesResponse: error,
        isGetRolesError: true,
        isGetRolesSuccess: false
    }
};